import { createAction, props } from '@ngrx/store';
import { Comment } from '../../models/Comment';

export const loadCommentsByReflex = createAction(
  '[Comment] Load By Reflex',
  props<{ reflexNo: string; isAdmin?: boolean }>()
);

export const loadCommentsByReflexSuccess = createAction(
  '[Comment] Load By Reflex Success',
  props<{ reflexNo: string; comments: Comment[] }>()
);

export const loadCommentsByReflexFailure = createAction(
  '[Comment] Load By Reflex Failure',
  props<{ reflexNo: string; error: string }>()
);

export const addComment = createAction(
  '[Comment] Add',
  props<{ reflexNo: string; commentText: string; clientId: string }>()
);

export const addCommentSuccess = createAction(
  '[Comment] Add Success',
  props<{ reflexNo: string; comment: Comment; clientId?: string }>()
);

export const updateComment = createAction(
  '[Comment] Update',
  props<{ comment: Comment }>()
);

export const updateCommentSuccess = createAction(
  '[Comment] Update Success',
  props<{ comment: Comment }>()
);

export const deleteComment = createAction(
  '[Comment] Delete',
  props<{ reflexNo: string; id: number }>()
);

export const deleteCommentSuccess = createAction(
  '[Comment] Delete Success',
  props<{ reflexNo: string; id: number }>()
);
